<template>
  <SpotlightGroupItems :items="liabilities">
    <template #item="props">
      <SpotlightGroupItem :item="props.item" @on-item-click="onItemClick(props.item)">
        <template #subtitle>
          <span>{{ props.item.typeEnum.value }}</span>
          <span class="is-inline-block m-l-3 m-r-3">•</span>
          <span class="has-text-ellipsis">{{ props.item.estate.fullName }}</span>
        </template>
      </SpotlightGroupItem>
    </template>
  </SpotlightGroupItems>
</template>

<script>
import { SpotlightGroup } from '@/modules/spotlight/models/SpotlightGroup';
import { Liability } from '@/modules/liability/models/Liability';
import { EstateDetailsCollapsesTabValue } from '@/modules/ops/constants/EstateDetailsCollapsesTabValue';
import SpotlightGroupItems from '@/modules/spotlight/components/presentational/SpotlightGroupItems.vue';
import { EstateDetailsShowConfig } from '@/modules/core/ui/models/EstateDetailsShowConfig';
import EstateDetailsService from '@/modules/core/ui/services/EstateDetailsService';
import SpotlightGroupItem from '@/modules/spotlight/components/presentational/SpotlightGroupItem.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightLiabilityGroup',
  emits: ['on-item-click'],
  components: { SpotlightGroupItem, SpotlightGroupItems },
  props: {
    group: SpotlightGroup
  },
  computed: {
    liabilities() {
      return Liability.mapModels(this.group.items);
    }
  },
  methods: {
    onItemClick(item) {
      this.$emit('on-item-click', item);
      EstateDetailsService.show(
        new EstateDetailsShowConfig({
          component: this,
          modelId: item.estateId,
          tab: EstateDetailsCollapsesTabValue.RELATED
        })
      );
    }
  }
};
</script>
